export const ADVANCED_COLOR = "#7FB685";
export const ADVANCED_COLOR_LIGHT = "#99c59d";
